import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';
import ArrowDownIcon from '../../../../../../public/images/icons/arrow_down.svg';
import ArrowUpIcon from '../../../../../../public/images/icons/arrow_up.svg';
import { Collapse } from '../../../Collapse';

export const Collapsible = styled(Collapse)(({ theme, isOpen }) => ({
  width: '100%',
  borderBottom: `1px solid ${isOpen ? theme.colors.surface05 : 'transparent'}`,
}));

export const CollapseActionContainer = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop: theme.spacing[16],
}));

export const CollapseAction = styled.button(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  columnGap: theme.spacing[8],
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
  padding: 0,
}));

export const ActionTitle = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
}));

interface IArrowIcon {
  isOpen: boolean;
  className?: string;
}

const ArrowIcon = ({ isOpen, className }: IArrowIcon) => {
  const Arrow = isOpen ? ArrowUpIcon : ArrowDownIcon;
  return <Arrow className={className} />;
};

export const CollapseArrow = styled(ArrowIcon)(({ theme }) => ({
  fill: theme.colors.mediumEmphasisBlack,
}));
